import React, { Component } from 'react';
import LoginForm from './LoginForm';
import './LoginPage.css';
import NavBar from "../NavBar/NavBar";

class LoginPage extends Component {
  render () {
    return (
      <div className="LoginPage">
          <NavBar showLess={true} />
          <div className="page-logo"></div>
          <LoginForm />
      </div>
    )
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/components/LoginPage/LoginPage.js